export default "__VITE_ASSET__a1c057d0__"